import { gql, useMutation } from '@apollo/client';
import { useToast } from 'components/ui/toast';
import {
	FileAccessLevelChangeRequest,
	Mutation,
	MutationFileInstanceAccessLevelChangeArgs,
} from 'middleware-types';
import { handleNoResponse, responseHasErrors } from 'utils/errors';
import { FILE_INSTANCE_INFO_FIELDS_NO_FOLDER } from '../../utils/fragments.graphql';

const CHANGE_INSTANCE_ACCESS_LEVEL = gql`
	${FILE_INSTANCE_INFO_FIELDS_NO_FOLDER}
	mutation ChangeInstanceAccessLevel($request: FileAccessLevelChangeRequest!) {
		fileInstanceAccessLevelChange(request: $request) {
			...FileInstanceInfoFieldsNoFolder
		}
	}
`;

export const useInstanceAccessLevelChange = () => {
	const toast = useToast();

	const [_changeInstanceAccessLevel] = useMutation<
		Pick<Mutation, 'fileInstanceAccessLevelChange'>,
		MutationFileInstanceAccessLevelChangeArgs
	>(CHANGE_INSTANCE_ACCESS_LEVEL, { onError: (e) => console.log(JSON.stringify(e)) });

	const changeInstanceAccessLevel = async (request: FileAccessLevelChangeRequest) => {
		return await _changeInstanceAccessLevel({ variables: { request } })
			.then((res) => {
				if (responseHasErrors(res.errors, { toast })) {
					return false;
				}
				toast.push('Privacy updated successfully.', { variant: 'success' });
				return true;
			})
			.catch(() => {
				handleNoResponse({ toast });
				return false;
			});
	};

	return changeInstanceAccessLevel;
};
